import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../../utils/utils';
const SOFT = {
    neutral: 'bg-neutral-100 text-neutral-700',
    info: 'bg-blue-50 text-blue-800',
    success: 'bg-emerald-50 text-emerald-800',
    warning: 'bg-amber-50 text-amber-800',
    danger: 'bg-red-50 text-red-800'
};
const OUTLINE = {
    neutral: 'border-neutral-200 text-neutral-600',
    info: 'border-blue-200 text-blue-700',
    success: 'border-emerald-200 text-emerald-700',
    warning: 'border-amber-200 text-amber-700',
    danger: 'border-red-200 text-red-700'
};
const COUNT = {
    neutral: 'bg-neutral-200 text-neutral-600',
    info: 'bg-blue-100 text-blue-800',
    success: 'bg-emerald-100 text-emerald-800',
    warning: 'bg-amber-100 text-amber-800',
    danger: 'bg-red-100 text-red-800'
};
const DOT = {
    neutral: 'bg-neutral-400',
    info: 'bg-blue-500',
    success: 'bg-emerald-500',
    warning: 'bg-amber-500',
    danger: 'bg-red-500'
};
// A short status, tag or count next to other content. The label is the children.
export const Badge = ({ tone = 'neutral', variant = 'soft', icon, dot = false, className, children, ...props }) => (_jsxs("span", { ...props, className: cn('inline-flex items-center gap-1.5 whitespace-nowrap font-roobert text-xs font-medium', variant === 'soft' && ['rounded-full px-2.5 py-0.5', SOFT[tone]], variant === 'outline' && [
        'rounded-md border border-solid bg-white px-2 py-0.5',
        OUTLINE[tone]
    ], variant === 'count' && [
        'h-5 min-w-5 justify-center rounded-md px-1.5 tabular-nums',
        COUNT[tone],
        'group-data-[active]:bg-primary-base group-data-[active]:text-white'
    ], className), children: [dot ? (_jsx("span", { "aria-hidden": "true", className: cn('size-1.5 shrink-0 rounded-full', DOT[tone]) })) : null, icon ? (_jsx("span", { "aria-hidden": "true", className: "inline-flex shrink-0 [&>svg]:size-3", children: icon })) : null, children] }));
